import { GET_CASHBACK_STATEMENT, GET_CASHBACK_STATEMENT_SUCCESS, GET_CASHBACK_STATEMENT_ERROR, GET_CASHBACK_STATEMENT_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetCashbackStatement = (state = initialState, action) => {
  switch (action.type) {
    case GET_CASHBACK_STATEMENT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_CASHBACK_STATEMENT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_CASHBACK_STATEMENT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_CASHBACK_STATEMENT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetCashbackStatement;
